import React, { useEffect, useState } from 'react';
import { getUserInfo } from '../services/userServicer';
import { getV2Token } from '../utils/v2AuthUtils';
import { isDemoUser } from '../utils/demoAuth';
import DashboardImplemetor from '../pages/DashboardImplementor/DashboardImplemetor';
import Dashboard from '../pages/dashboard/Dashboard';
import DemoDashboard from '../pages/demo/DemoDashboard';

interface RoleBasedRouteProps {
  children?: React.ReactNode;
}

const RoleBasedRoute: React.FC<RoleBasedRouteProps> = ({ children }) => {
  const [userRole, setUserRole] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isDemo, setIsDemo] = useState(false);

  useEffect(() => {
    const token = getV2Token();
    if (token && isDemoUser(token)) {
      setIsDemo(true);
      setIsLoading(false);
      return;
    }

    const getUserRole = async () => {
      try {
        setIsLoading(true);
        const userData = await getUserInfo();
        setUserRole(userData?.group?.name ?? userData?.groupName ?? null);
      } catch (err) {
        console.error("Error getting user role:", err);
        setUserRole(null);
      } finally {
        setIsLoading(false);
      }
    };

    getUserRole();
  }, []);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (isDemo) {
    return <DemoDashboard />;
  }

  // If children are provided, render them (for custom role-based components)
  if (children) {
    return <>{children}</>;
  }

  // Default dashboard routing based on role
  if (userRole === 'Compliance_Implementor') {
    return <DashboardImplemetor />;
  }

  return <Dashboard />;
};

export default RoleBasedRoute;
